import { Button } from '@mui/material'
import React from 'react'
import { useTheme } from '../../../../utils/themeContext'
import { getColorsForTheme } from '../../../../global-styles/clientColors'

const ListVehicleCell = (props) => {
  let {
    formattedValue: { vehicle, isEligible },
    handler,
  } = props

  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)

  if (vehicle.vehicle) {
    vehicle = vehicle.vehicle
  }

  return (
    <Button
      color="secondary"
      onClick={() => {
        handler(vehicle)
      }}
      variant="contained"
      sx={{
        backgroundColor: themeColors.buttonColor,
        color: currentTheme === 'galpin' ? 'black' : 'white',
        '&:hover': {
          backgroundColor: themeColors.buttonHover,
        },
      }}
    >
      {isEligible ? 'Delist' : 'List'}
    </Button>
  )
}

export default ListVehicleCell
